"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var urlBuilder = require("./urlBuilder");
// Exported Functions
var SCHEME_SEPERATOR = '://';
exports.extractScheme = function (url) {
    if (url === null || url === undefined) {
        return null;
    }
    var idx = url.indexOf(SCHEME_SEPERATOR);
    return idx >= 0 ? url.substr(0, idx) : null;
};
exports.extractSchemeAndDomain = function (url) {
    var scheme = exports.extractScheme(url);
    if (scheme === null) {
        return null;
    }
    var idx = url.indexOf('/', scheme.length + SCHEME_SEPERATOR.length);
    return idx >= 0 ? url.substr(0, idx) : url;
};
exports.extractQueryString = function (url) {
    if (!url) {
        return url;
    }
    var pathAndQuery = extractPathAndQueryString(url);
    if (!pathAndQuery) {
        return '';
    }
    var idx = pathAndQuery.indexOf('?');
    return idx >= 0 ? pathAndQuery.substr(idx + 1) : '';
};
var extractPathAndQueryString = function (url) {
    var schemeAndDomain = exports.extractSchemeAndDomain(url);
    return url && url.substr(schemeAndDomain.length);
};
exports.extractPath = function (url, options) {
    if (options && options.removeQueryString) {
        var pathAndQuery = extractPathAndQueryString(url);
        var idx = pathAndQuery.indexOf('?');
        return idx >= 0 ? pathAndQuery.substr(0, idx) : pathAndQuery;
    }
    else {
        return extractPathAndQueryString(url);
    }
};
exports.extractSchemeDomainAndPath = function (url, options) {
    var schemeAndDomain = exports.extractSchemeAndDomain(url);
    var path = exports.extractPath(url, options);
    return path ? urlBuilder.combine(schemeAndDomain, path) : schemeAndDomain;
};
exports.parseParams = function (url) {
    var result = {};
    var queryString = exports.extractQueryString(url);
    if (queryString) {
        var parts = queryString.split('&');
        parts.forEach(function (keyValue) {
            var idx = keyValue.indexOf('=');
            var key = idx >= 0 ? keyValue.substr(0, idx) : keyValue;
            var value = idx >= 0 ? decodeURIComponent(keyValue.substr(idx + 1)) : null;
            result[key] = value;
        });
    }
    return result;
};
